import { Helmet } from 'react-helmet-async';

import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// @mui
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import PropTypes from 'prop-types';

import {
  DeleteAttachment,
  DownloadTreeAttachment,
  GetAttachmentsList,
  GetCompany,
  GetTask,
  MarkAsDoneReq,
  MarkAsWronglyAssignedReq,
  PostAttachment,
  PostPerformActivity,
} from 'src/components/services/httpServices';

import { Trash } from 'react-feather';
import { Download } from 'react-feather/dist';
import ActivitesHistory from 'src/components/Opportunities/ActivitesHistory';
import TasksListAgainstClient from 'src/components/Opportunities/TasksListAgainstClient';
import ModalLayout from 'src/theme/Modal';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function CompanyDetailsPage() {
  let { id, checkClient, taskId } = useParams();
  const navigate = useNavigate();
  const [company, setCompany] = useState({});
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');
  const [attachments, setAttachments] = useState({});
  const [selectedFile, setSelectedFile] = useState([]);
  const [task, setTask] = useState(null);
  const [ACTIVITIESLIST, setActivitiesList] = useState([]);
  const [scannedDate, setScannedDate] = useState(null);

  const attachmentRef = useRef(null);
  const activityTypeRef = useRef('');
  const activitiyDateRef = useRef('');
  const activityTimeRef = useRef('');
  const followUpDateRef = useRef('');
  const commentsRef = useRef('');
  const nextStageRef = useRef('');
  const detailsRef = useRef('');
  const fetchAttachments = async (event) => {
    let attachments = await GetAttachmentsList(id, checkClient);
    setAttachments(attachments);
  };
  const fetchCompany = async (event) => {
    const company = await GetCompany(id);
    const attachments = await GetAttachmentsList(id, checkClient);
    const task = await GetTask(taskId);
    setAttachments(attachments);
    setCompany(company);
    setTask(task.data);
    setLoading(false);
  };
  useEffect(() => {
    fetchCompany();
  }, [selectedFile]);

  const handleClose = () => {
    setOpen(false);
  };
  const PerformActivity = async (event) => {
    event.preventDefault();

    // console.log('editHit');
    setLoading(true);
    var payload = {};
    if (checkClient == 'true') {
      payload = {
        activityType: activityTypeRef.current.value,
        activityDate: activitiyDateRef.current.value,
        activityTime: activityTimeRef.current.value,
        followUpDate: followUpDateRef.current.value,
        comments: commentsRef.current.value,
        nextStage: nextStageRef.current.value,
        clientId: checkClient == 'true' ? id : null,
        companyIdList: [],
        clientIdList: [],
        details: detailsRef.current.value,
        subActivities: [],
      };
    } else {
      payload = {
        activityType: activityTypeRef.current.value,
        activityDate: activitiyDateRef.current.value,
        activityTime: activityTimeRef.current.value,
        followUpDate: followUpDateRef.current.value,
        comments: commentsRef.current.value,
        nextStage: nextStageRef.current.value,
        companyId: checkClient == 'false' ? id : null,
        companyIdList: [],
        clientIdList: [],
        subActivities: [],
      };
    }

    // console.log(payload);
    let response = await PostPerformActivity(payload);
    // console.log('PostResponse:', response);
    if (response.status == 200) {
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(`/app/MyTasks`);
      }, 2000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };

  const MarkAsDone = async (event) => {
    // if (ACTIVITIESLIST.length <= 0) {
    //   alert('Perform an activity first!');
    // } else {
    event.preventDefault();
    setLoading(true);
    let response = await MarkAsDoneReq(taskId);
    //  console.log('PostResponse:', response);
    if (response.status == 200) {
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(`/app/MyTasks`);
      }, 2000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(`/app/MyTasks`);
      }, 2000);
      // setPosting(false);
    }
    // }
  };

  const MarkAsWronglyAssigned = async (event) => {
    event.preventDefault();
    setLoading(true);
    let response = await MarkAsWronglyAssignedReq(taskId);
    //  console.log('PostResponse:', response);
    if (response.status == 200) {
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(`/app/MyTasks`);
      }, 2000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(`/app/MyTasks`);
      }, 2000);
      // setPosting(false);
    }
  };
  const SaveAttachment = async (event) => {
    event.preventDefault();
    setLoading(true);
    var payload = selectedFile;
    //  console.log(payload);
    let response = await PostAttachment(id, payload, checkClient);
    // console.log('PostResponse:', response);
    if (response.status == 200) {
      fetchAttachments();
      setSelectedFile([]);
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setLoading(false);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };
  const uploadFile = (event) => {
    event.preventDefault();
    const uploaded = [...selectedFile];
    for (let i = 0; i < event.target.files.length; i++) {
      let reader = new FileReader();
      let file = event.target.files[i];
      //    console.log('FileName', file); //I can see the file's info

      reader.onload = (event) => {
        //    console.log('event', event.target.result[i]);
        // console.log("asas", reader.result);
        const row = {
          attachment: reader.result,
          fileName: file.name,
          docType: '',
          scannedDate: currentDateStr,
          docExpiryDate: '',
        };
        uploaded.push(row);
        // setSelectedFile([row]);
        // console.log('row', row);
        // console.log("State", selectedFile);
      };
      reader.readAsDataURL(file);

      // console.log('asas', reader.result);
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    }
    setSelectedFile(uploaded);
  };
  const deleteAttachmentRow = (fileName) => {
    //console.log(selectedFile);
    const newList = selectedFile.filter((item) => item.fileName !== fileName);
    //console.log('new List', newList);

    // setGrandTotal(parseInt(grandTotal) - price * quantity);
    setSelectedFile(newList);
  };
  const GetAttachment = async (path) => {
    //var file = await DownloadAttachment(path);
    var file = await DownloadTreeAttachment('1', false, '', path, false);
    //console.log('file', file);
    const url = window.URL.createObjectURL(new Blob([file.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', path); //or any other extension
    document.body.appendChild(link);
    link.click();
  };
  const deleteAttachment = async (attachment) => {
    event.preventDefault();
    setLoading(true);

    // console.log('IDD:', attachment);
    let response = await DeleteAttachment(attachment);
    // console.log('Console:', response);
    if (response.status == 200) {
      const newList = attachments.filter((item) => item.id !== attachment);
      setAttachments(newList);
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setLoading(false);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      setLoading(false);
    }
  };
  const ChangeDateHandle = (event, index) => {
    setScannedDate(event.target.value);
    //  console.log(index);
    //  console.log(event.target.value);
    selectedFile[index].scannedDate = event.target.value;
    //  console.log(selectedFile);
  };
  const ChangeDocTypeHandle = (event, index, type) => {
    //  console.log(index);
    //  console.log(type);
    selectedFile[index].docType = type?.value;
  };
  const ChangeExpiryDateHandle = (event, index) => {
    selectedFile[index].docExpiryDate = event.target.value;
    // console.log(selectedFile);
  };
  const docTypes = [{ value: 'Identity Card' }, { value: 'Passport' }];

  const currentDate = new Date();
  const currentHour = currentDate.getHours().toString().padStart(2, '0');
  const currentMinute = currentDate.getMinutes().toString().padStart(2, '0');
  const currentTime = `${currentHour}:${currentMinute}:00`;

  const currentYear = currentDate.getFullYear().toString();
  const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // add 1 to get the correct month
  const currentDay = currentDate.getDate().toString().padStart(2, '0');
  const currentDateStr = `${currentYear}-${currentMonth}-${currentDay}`;
  return (
    <>
      <Helmet>
        <title> Employer | Immigration System </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Employer Details
          </Typography>

          <Stack direction="row" spacing={2}>
            <Button
              onClick={() => {
                navigate(-1);
              }}
              variant="contained"
            >
              Back
            </Button>
          </Stack>
        </Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <>
            <Box
              p={4}
              marginBottom={4}
              component={Paper}
              boxShadow={3}
              sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
            >
              <Grid container spacing={3}>
                <Grid item xs={6} sm={3} md={12}>
                  <Typography variant="h6" color="initial">
                    <span style={{ color: '#ad1f22' }}>{task?.activityName}:</span>
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    <span style={{ color: '#ad1f22' }}>{task?.comments}</span>
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Full Name :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyName}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Company GST :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyGst}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Business Type :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.businessInformations[0]?.businessType}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Business Address :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyContactInformations[0]?.businessAddress}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Mailing Address :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyContactInformations[0]?.mailingAddress}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Business Phone Number :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyContactInformations[0]?.businessPhoneNumber}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Email Address :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyContactInformations[0]?.employerEmailAddress}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Company Website :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyContactInformations[0]?.companyWebsite}
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
              <Typography variant="h4" gutterBottom>
                Task Information
              </Typography>
            </Stack>
            <Box
              p={4}
              marginBottom={4}
              component={Paper}
              boxShadow={3}
              sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
            >
              <Grid container spacing={3}>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Title :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.activityName}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Details :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.comments}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Task Status :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.status}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Created Date :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.createdDate?.split('T')[0]}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Deadline :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.deadLine?.split('T')[0]}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Assignet to :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.assignedToUserName}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Assignet By :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.assignedByName}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Client's Name :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.prospectName}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Client's Email :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.prospectEmail}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Invoice No :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.invoiceNo}
                  </Typography>
                </Grid>

                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Is in Canada :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.isInsideCanada == true ? 'Yes' : 'No'}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Client's Country :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.prospectCountry}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Client's Status :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.prospectStatus}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Is working with Employer :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.isWorkingWithEmp == true ? 'Yes' : 'No'}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Working Start Date :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {task?.workingStartDate?.split('T')[0]}
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            <>
              {' '}
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                md={5}
                marginTop={4}
                spacing={2}
              >
                <Typography variant="h4" gutterBottom>
                  Clients Info
                </Typography>
              </Stack>
              <Container>
                <Box
                  p={3}
                  component={Paper}
                  boxShadow={3}
                  marginBottom={4}
                  marginTop={4}
                  sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TableContainer component={Paper}>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell>Client's Name</TableCell>
                              <TableCell>Client's Email</TableCell>
                              <TableCell>Invoice No</TableCell>
                              <TableCell>Is in Side Canada</TableCell>
                              <TableCell>Country</TableCell>

                              <TableCell>Status</TableCell>
                              <TableCell>Is Working with Employer</TableCell>

                              <TableCell>Working with Employer Date</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {task?.subActivitysClients?.map((row, index) => (
                              <TableRow key={index + 1}>
                                <TableCell>{row.clientName}</TableCell>
                                <TableCell>{row.clinetEmail}</TableCell>
                                <TableCell>{row.invoiceNumber}</TableCell>
                                <TableCell>{row.isInCanada == true ? 'Yes' : 'No'}</TableCell>
                                <TableCell>{row.isInCanada == true ? 'Canada' : row.outSideCountry}</TableCell>
                                <TableCell>{row.status}</TableCell>
                                <TableCell>{row.isWorkingWithEmployer == true ? 'Yes' : 'No'}</TableCell>
                                <TableCell>{row?.startDate?.split('T')[0]}</TableCell>
                                {/* <TableCell>
                                        <IconButton
                                          onClick={() => deleteAttachmentRow(row.fileName)}
                                          aria-label="delete"
                                          size="small"
                                        >
                                          <Trash />
                                        </IconButton>
                                      </TableCell> */}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
                </Box>
              </Container>
            </>

            {task?.status !== 'Done' ? (
              <form onSubmit={PerformActivity}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                  <Typography variant="h4" gutterBottom>
                    Perform Activity
                  </Typography>

                  <Stack direction="row" spacing={2}>
                    <Button variant="outlined">
                      <ModalLayout
                        title="Mark as Wrongly Assigned"
                        description="Are You sure you want to Mark as Wrongly Assigned?"
                        Hit={MarkAsWronglyAssigned}
                      />
                    </Button>
                    <Button variant="outlined">
                      <ModalLayout
                        title="Mark as Done"
                        description="Are You sure you want to Mark as Done?"
                        Hit={MarkAsDone}
                      />
                    </Button>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Stack>
                </Stack>

                <Box
                  p={3}
                  component={Paper}
                  boxShadow={3}
                  marginBottom={4}
                  sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Activity Type"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={activityTypeRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Activity Date"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        type="date"
                        // defaultValue={user.userName}
                        InputLabelProps={{ shrink: true }}
                        inputRef={activitiyDateRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Activity Time"
                        required
                        type="time"
                        variant="outlined"
                        fullWidth
                        size="small"
                        // defaultValue={user.password}
                        InputLabelProps={{ shrink: true }}
                        inputRef={activityTimeRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Follow Up Date"
                        variant="outlined"
                        fullWidth
                        size="small"
                        type="date"
                        // defaultValue={user.userEmail}
                        inputRef={followUpDateRef}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Comments"
                        variant="outlined"
                        fullWidth
                        size="small"
                        // defaultValue={user.userEmail}
                        inputRef={commentsRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Next Stage"
                        variant="outlined"
                        fullWidth
                        size="small"
                        // defaultValue={user.userEmail}
                        inputRef={nextStageRef}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </form>
            ) : null}

            {task?.status !== 'Done' ? (
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                <Typography variant="h4" gutterBottom>
                  Add Documents
                </Typography>
                <Typography variant="h4" marginRight={12} gutterBottom></Typography>
                <Typography variant="h4" marginRight={12} gutterBottom></Typography>
                <Typography variant="h4" marginRight={12} gutterBottom></Typography>
                <Typography variant="h4" marginRight={12} gutterBottom></Typography>

                <TextField
                  type="file"
                  label=""
                  inputProps={{ multiple: true }}
                  inputRef={attachmentRef}
                  onChange={uploadFile}
                />
                <Button onClick={SaveAttachment} variant="contained">
                  Attach
                </Button>
              </Stack>
            ) : null}
            {task?.status !== 'Done' ? (
              <Box
                p={3}
                component={Paper}
                boxShadow={3}
                marginBottom={4}
                sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <br></br>
                    <br></br>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Sr#</TableCell>

                            <TableCell>Attachment Name</TableCell>
                            <TableCell>Scanned Date</TableCell>
                            <TableCell>Document Type</TableCell>
                            <TableCell>Document Expiry Date</TableCell>
                            <TableCell>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selectedFile?.map((row, index) => (
                            <TableRow key={index + 1}>
                              <TableCell>{index + 1}</TableCell>

                              <TableCell>{row.fileName}</TableCell>

                              <TableCell>
                                <TextField
                                  label="Scaned Date"
                                  variant="outlined"
                                  fullWidth
                                  defaultValue={currentDateStr}
                                  size="small"
                                  type="date"
                                  onChange={(event) => ChangeDateHandle(event, index)}
                                  InputLabelProps={{ shrink: true }}
                                />{' '}
                              </TableCell>

                              <TableCell>
                                <Autocomplete
                                  id="docType"
                                  size="small"
                                  options={docTypes}
                                  // defaultValue={userList.find((e) => e.key == user.deptId)}
                                  getOptionLabel={(source) => source.value}
                                  renderInput={(params) => (
                                    <TextField {...params} label="Doc Type" variant="outlined" />
                                  )}
                                  onChange={(event, type) => ChangeDocTypeHandle(event, index, type)}
                                />
                              </TableCell>
                              <TableCell>
                                <TextField
                                  label="Doc Expiry Date"
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  type="date"
                                  onChange={(event) => ChangeExpiryDateHandle(event, index)}
                                  InputLabelProps={{ shrink: true }}
                                />{' '}
                              </TableCell>
                              <TableCell>
                                <IconButton
                                  onClick={() => deleteAttachmentRow(row.fileName)}
                                  aria-label="delete"
                                  size="small"
                                >
                                  <Trash />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Box>
            ) : null}
            {task?.status !== 'Done' ? (
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                <Typography variant="h4" gutterBottom>
                  Saved Documents
                </Typography>
              </Stack>
            ) : null}
            {task?.status !== 'Done' ? (
              <Box
                p={3}
                component={Paper}
                boxShadow={3}
                sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <br></br>
                    <br></br>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Sr#</TableCell>
                            <TableCell>Document Name</TableCell>

                            <TableCell>Scanned Date</TableCell>
                            <TableCell>Document Type</TableCell>
                            <TableCell>Document Expiry</TableCell>
                            <TableCell>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {attachments?.map((row, index) => (
                            <TableRow key={index + 1}>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{row.docName}</TableCell>
                              {/* <TableCell>{row.name}</TableCell> */}
                              {/* <TableCell>
                            <Link
                              href="#"
                              // onClick={() => {
                              //   window.open(`C:\Attachment Folder\ ${row.name}, '_blank`);
                              // }}
                              onClick={() => GetAttachment(row.name)}
                            >
                              {row.name}
                            </Link>
                          </TableCell> */}
                              <TableCell>{row.scannedDate?.split('T')[0]}</TableCell>
                              <TableCell>{row.docType}</TableCell>
                              <TableCell>{row.docExpiryDate?.split('T')[0]}</TableCell>
                              <TableCell>
                                <IconButton onClick={() => GetAttachment(row.path)} aria-label="delete" size="small">
                                  <Download />
                                </IconButton>
                                <IconButton aria-label="delete" size="small">
                                  <ModalLayout
                                    // title="Delete"
                                    component={<Trash />}
                                    description="Are You Sure you want to Delete?"
                                    Hit={() => deleteAttachment(row.id)}
                                  />
                                  {/* <Trash borderColor='red' /> */}
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Box>
            ) : null}
          </>
        )}
      </Container>
      {task?.status !== 'Done' ? <ActivitesHistory setActivitiesList={setActivitiesList} /> : null}
      {task?.status !== 'Done' ? <TasksListAgainstClient /> : null}
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
